/* istanbul ignore file */

import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { TreeviewCheckedSelection } from '@mirage-projects/cw-models';

/**
 * Service to manage the toc state
 */
@Injectable({ providedIn: 'root' })
export class TocManagementService {
    private reloadTocSubject$ = new Subject<void>();
    private reloadTocObservable$ = this.reloadTocSubject$.asObservable();

    private selectNodeByIdSubject$ = new Subject<number | string>();
    private selectNodeByIdObservable$ = this.selectNodeByIdSubject$.asObservable();

    private checkedNodeChangeSubject$ = new Subject<TreeviewCheckedSelection>();
    checkedNodeChange$ = this.checkedNodeChangeSubject$.asObservable();

    /**
     * Tells the subscribed Toc components to reload their content
     */
    reloadToc(): void {
        this.reloadTocSubject$.next();
    }

    /**
     * Returns the observable to listen when a toc reload is needed
     */
    onReloadToc(): Observable<void> {
        return this.reloadTocObservable$;
    }

    /**
     * Tells the subscribed Toc components to select a node
     */
    selectNodeById(idNode: string): void {
        this.selectNodeByIdSubject$.next(idNode);
    }

    /**
     * Returns the observable to listen when a new selection is needed
     */
    onSelectNodeById(): Observable<string | number> {
        return this.selectNodeByIdObservable$;
    }

    checkedNodeChange(treeViewSelection: TreeviewCheckedSelection): void {
        this.checkedNodeChangeSubject$.next(treeViewSelection);
    }
}
